import React, { useEffect, useState } from "react";
import "./Review.css";

import r1 from "../assets/review1.jpeg";
import r2 from "../assets/review2.jpeg";
import r3 from "../assets/review3.jpeg";
import r4 from "../assets/review4.jpeg";
import r5 from "../assets/review5.jpeg";
import r6 from "../assets/review6.jpeg";
import r7 from "../assets/review7.jpeg";
import r8 from "../assets/review8.jpeg";
import r9 from "../assets/review9.jpeg";

const images = [r1, r2, r3, r4, r5, r6, r7, r8, r9];

const Review = () => {
  const [index, setIndex] = useState(0);
  const [zoomed, setZoomed] = useState(false);

  // AUTO SLIDE (every 6 sec)
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="review-section">
      <h2>Patient Reviews</h2>

      <div className="review-container">
        <img
          key={index}
          src={images[index]}
          alt="review"
          onClick={() => setZoomed(true)}
          className="review-image"
        />
      </div>

      {/* ZOOM MODAL */}
      {zoomed && (
        <div className="review-modal" onClick={() => setZoomed(false)}>
          <img src={images[index]} alt="zoomed" />
        </div>
      )}
    </section>
  );
};

export default Review;